/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as TYPES from "./action-types";
const intialState = {
  loading: false,
  userDefault: null,
  rebateDropdownData: [],
  stubInvoiceFilter: {},
  errorMessages: [],
};

const reducer = (state = intialState, action) => {
  switch (action.type) {
    case TYPES.CREATE_STUB_INVOICE_LOADING:
      return { ...state, loading: action.payload };
    case TYPES.CREATE_STUB_INVOICE_REBATE_PROGRAM_DATA:
      return { ...state, rebateDropdownData: action.payload };
    case TYPES.CREATE_STUB_INVOICE_FILTER:
      return { ...state, stubInvoiceFilter: action.payload };
    case TYPES.CREATE_STUB_INVOICE_USERDEFAULT:
      return { ...state, userDefault: action.payload };
    case TYPES.SET_ERROR_MESSAGES:
      return { ...state, errorMessages: action.payload };
    case TYPES.CREATE_STUB_INVOICE_RESET_STORE:
      return { ...intialState };
    default:
      return state;
  }
};

export default reducer;
